import { render, staticRenderFns } from "./liaotianjilu1.vue?vue&type=template&id=63cc1155"
import script from "./liaotianjilu1.vue?vue&type=script&lang=js"
export * from "./liaotianjilu1.vue?vue&type=script&lang=js"
import style0 from "./liaotianjilu1.vue?vue&type=style&index=0&id=63cc1155&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports